import {Pipe, PipeTransform} from '@angular/core';
interface States {
  [x: string]: string;
}
export const EXPORT_STATUS: States = {
  pending: '排队中',
  processing: '正在处理中',
  completed: '已完成',
  failed: '失败',
};

@Pipe({
  name: 'exportStatus',
})
export class ExportStatusPipe implements PipeTransform {
  transform(value: string): string {
    return EXPORT_STATUS[value] || '';
  }
}
